import { injectGlobal } from '@emotion/css';

injectGlobal(`
  :root {
    --max-content-width: 50rem;
  }
`);
